interface Operation<I extends any[], O> {
    (abortSignal: AbortSignal, ...args: I): Promise<O>;
}

interface SingleFlight<I extends any[], O> {
    run(...args: I): Promise<O>;
}

export function createSingleFlight<I extends any[], O>(
    operation: Operation<I, O>
): SingleFlight<I, O> {
    let activeController: AbortController | null = null;

    return {
        async run(...args) {
            if (activeController) {
                activeController.abort();
            }

            activeController = new AbortController();

            try {
                return await operation(activeController.signal, ...args);
            } finally {
                activeController = null;
            }
        },
    };
}
